import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import "@tameeni/shared-logic/theme.styles.css";
import "@tameeni/shared-logic/theme-variables.css";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
